import type { Entity } from '@backstage/catalog-model';

import { shuffle } from 'es-toolkit';
import { useState } from 'react';

export const useShuffledEntities = <T extends Entity>(entities?: T[]) => {
  const [snapshot, setSnapshot] = useState(() => ({
    entities,
    ordered: shuffle(entities ?? []),
  }));

  if (snapshot.entities !== entities) {
    const changed = JSON.stringify(snapshot.entities) !== JSON.stringify(entities);
    const next = {
      entities,
      ordered: changed ? shuffle(entities ?? []) : snapshot.ordered,
    };

    setSnapshot(next);

    return next.ordered;
  }

  return snapshot.ordered;
};
